export default __webpack_public_path__ + "static/media/CT_Wireframes.e4b8a362.png";